function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "10.583mm",
    height: "10.583mm",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BG"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_11",
    "data-name": "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,7.5h30v15H0V7.5Z",
    style: {
      fill: "red"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,7.5h30v10H0V7.5Z",
    style: {
      fill: "blue"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,7.5h30v5H0v-5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.681,10.383c1.159-.511,2.479-.511,3.638,0,.19,2.687-.416,4.209-1.819,4.568-1.403-.359-2.009-1.881-1.819-4.568Z",
    style: {
      fill: "blue"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M7.5,10.866l.055.125.136-.015-.081.11.081.11-.136-.015-.055.125-.055-.125-.136.015.081-.11-.081-.11.136.015",
    style: {
      fill: "#ff0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a1",
    "data-name": "a",
    d: "M6.986,10.181l.055.125.136-.015-.081.11.081.11-.136-.015-.055.125-.055-.125-.136.015.081-.11-.081-.11.136.015",
    style: {
      fill: "#ff0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a2",
    "data-name": "a",
    d: "M8.014,10.181l.055.125.136-.015-.081.11.081.11-.136-.015-.055.125-.055-.125-.136.015.081-.11-.081-.11.136.015",
    style: {
      fill: "#ff0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5,11.575l.44.881.294-.391.734.979c0,.045-.006.091-.019.134-.204.715-.745,1.284-1.449,1.525-.703-.24-1.245-.81-1.449-1.525-.012-.044-.019-.089-.019-.134l.734-.979.294.391.44-.881Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M6.051,13.177c.074.26.345.41.605.336.039-.011.076-.027.11-.047.151-.087.338-.087.489,0s.338.087.489,0,.338-.087.489,0c.234.135.533.055.668-.179.02-.035.036-.072.047-.11l.019.007v.358c-.086,0-.17.023-.245.066-.151.087-.338.087-.489,0s-.338-.087-.489,0-.338.087-.489,0-.338-.087-.489,0-.338.087-.489,0c-.074-.043-.159-.066-.245-.066v-.358",
    style: {
      fill: "blue"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "b1",
    "data-name": "b",
    d: "M6.051,13.46c.074.26.345.41.605.336.039-.011.076-.027.11-.047.151-.087.338-.087.489,0s.338.087.489,0,.338-.087.489,0c.234.135.533.055.668-.179.02-.035.036-.072.047-.11l.019.007v.358c-.086,0-.17.023-.245.066-.151.087-.338.087-.489,0s-.338-.087-.489,0-.338.087-.489,0-.338-.087-.489,0-.338.087-.489,0c-.074-.043-.159-.066-.245-.066v-.358",
    style: {
      fill: "blue"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.543,10.447c.046-.022.092-.043.138-.064l.145,2.321c.062.992.727,1.845,1.673,2.147.947-.302,1.611-1.155,1.673-2.147l.145-2.322c.046.021.093.042.138.064l-.142,2.267c-.065,1.067-.789,1.98-1.813,2.287-1.024-.307-1.748-1.22-1.815-2.287l-.142-2.266Z",
    style: {
      fill: "red"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSi);
export default __webpack_public_path__ + "static/media/SI.41aea169e3fd40ed453e4d5c49780dd3.svg";
export { ForwardRef as ReactComponent };